import { useContext } from 'react';
import { BarrioContext } from '../BarrioContext';

const PdfCuentaBancaria = () => {
    const { barrio } = useContext(BarrioContext);

    return (
        <>
            <div className="pdf-cuenta-box">Cuenta Bancaria para realizar los pagos:</div>
            <div className="pdf-cuenta-datos">
                <div>{barrio.cuentaBancaria}</div>
                <div>Titular: {barrio.razonSocial}</div>
                <div>CUIT: {barrio.cuit}</div>
                <div>{barrio.tipoCuentaBancaria} Nº: {barrio.numeroCuenta}</div>
                <div>Alias: {barrio.alias}</div>
            </div>

            <div className="pdf-aviso-box">
                Se solicita informar el pago <strong><u>UNICAMENTE</u></strong> en el caso que haya realizado
                un pago por un importe que no sea el exacto de la liquidación.
            </div>
        </>
    );
};

export default PdfCuentaBancaria;
